import { render } from "./changeRoom.vue?vue&type=template&id=8826b6fa"
import script from "./changeRoom.vue?vue&type=script&lang=js"
export * from "./changeRoom.vue?vue&type=script&lang=js"

import "./changeRoom.vue?vue&type=style&index=0&id=8826b6fa&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__